import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { getApi } from "../api";

export default () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ accountId, payload }: {
            accountId: number;
            payload: Record<string, unknown>;
        }) => {
            const { api, baseURL } = getApi();
            return api
                .put(`/api/accounts/${accountId}`, payload, { baseURL })
                .then((res) => res.data.data);
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ["account", variables.accountId] });
        },
    });
};
